import React from 'react'
import { Box, Heading, Grid, GridItem } from '@chakra-ui/react'
import { AiFillStar } from 'react-icons/ai'

const Info = ({ item, fontFamily, skin, isBusiness }) => {
  // Se usa el nombre de la sucursal para alimentar las cards de la sección venues
  return (
    <Grid w='100%' templateColumns='repeat(12, 2fr)'>
      <GridItem
        colSpan={[8, 8, 8, 8]}
        display='flex'
        alignItems='center'
        justifyContent='flex-start'
      >
        <Heading
          color={skin === 'COPPEL' ? 'brand.secondary' : 'brand.secondaryDark'}
          m='0'
          fontSize={['lg', 'lg', 'lg', 'lg']}
          fontFamily={fontFamily}
          fontWeight='500'
        >
          {isBusiness ? item.business.name : item?.venue?.name}
        </Heading>
      </GridItem>
      {!isBusiness && (
        <GridItem
          colSpan={[4, 4, 4, 4]}
          display='flex'
          alignItems='center'
          justifyContent='center'
        >
          <Box
            w='100%'
            display='flex'
            alignItems='center'
            justifyContent='flex-end'
            flexDirection='row'
          >
            <Heading
              m='0'
              pr='3px'
              color='brand.secondaryDark'
              fontSize={['sm', 'sm', 'sm', 'sm']}
              fontFamily={fontFamily}
              fontWeight='500'
            >
              {item.price_level === 0 || item.price_level === 1
                ? '$'
                : item.price_level === 2
                ? '$$'
                : item.price_level === 3
                ? '$$$'
                : '$$$$'}{' '}
              •
            </Heading>
            <AiFillStar color={skin === 'CLARA' ? '#1F2223' : '#FFD700'} />
            <Heading
              m='0'
              pl='5px'
              color='brand.secondaryDark'
              fontSize={['sm', 'sm', 'sm', 'sm']}
              fontFamily={fontFamily}
              fontWeight='500'
            >
              {item.rating}
            </Heading>
          </Box>
        </GridItem>
      )}
    </Grid>
  )
}

export default Info
